export default __webpack_public_path__ + "static/logo-duta-pertiwi-dcaba23af5f0d511923385859ed32c30.svg";